// Form validation for Company contact form - MSP Configuration
import { plaintextValidator } from '../fields';

const config = { mandatory: true };
// /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)$/i
const customPortalChecker = {
  subDomain: {
    regexChecker: {
      regex: /^(?!-)(?!.*--)[A-Za-z0-9-]{1,63}$/
    }
  }
};
export const jestRegex = customPortalChecker.subDomain.regexChecker.regex;

export default (mandateDomain) =>
  mandateDomain
    ? {
        subDomain: plaintextValidator(config),
        ...customPortalChecker
      }
    : { subDomain: plaintextValidator(config) };
